/**
 * Smooth same-page scroll for the rating-breakdown block's "See all
 * reviews" and "Reviews" links, matching the reference behavior of
 * preventDefault + scrollIntoView({ behavior: 'smooth', block: 'start' })
 * on the review list - no modal, no tab switch, just a smooth jump to
 * the existing reviews already on the page.
 */

/**
 * @param {Element} root
 */
function init(root) {
  root.querySelectorAll('.rating-breakdown__see-all, .rating-breakdown__cta').forEach((link) => {
    if (link.hasAttribute('data-smooth-scroll-bound')) return;
    link.setAttribute('data-smooth-scroll-bound', 'true');

    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#') || href.length < 2) return;

      const target = document.querySelector(href);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

init(document);

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof ParentNode) init(event.target);
});
